import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const AdvertiseSplash = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const advertisement = location.state?.advertisement;
    const token = localStorage.getItem('token');
    const [count, setCount] = useState(5);

    const handleSkip = () => {
        if (!token) {
            navigate('/mobileNumber', { replace: true });
        } else {
            navigate('/advertiseScreen', { replace: true });
        }
    };

    useEffect(() => {
        if (count === 0) {
            handleSkip();
            return;
        }

        const interval = setInterval(() => {
            setCount((prev) => prev - 1);
        }, 1000);

        return () => clearInterval(interval);
    }, [count]);

    return (
        <Box
            sx={{
                height: '100vh',
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: '#000',
                position: 'relative'
            }}
        >
            {advertisement && (
                <img
                    src={advertisement}
                    alt="Splash Advertisement"
                    style={{
                        height: '100%',
                        width: '100%',
                        objectFit: 'cover'
                    }}
                />
            )}

            <Box
                onClick={handleSkip}
                sx={{
                    position: 'absolute',
                    top: 20,
                    right: 20,
                    px: 2,
                    py: 1,
                    borderRadius: '20px',
                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                    color: '#fff',
                    fontSize: '14px',
                    fontWeight: 500,
                    cursor: 'pointer',
                    userSelect: 'none',
                    zIndex: 2
                }}
            >
                Skip {count}
            </Box>
        </Box>
    );
};

export default AdvertiseSplash;